var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Перегляд фото")]),_c('v-card-text',[_c('img',{attrs:{"width":"600","alt":"","src":_vm.photoUrlFull}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }